export const base_url = 'https://api.juliettecleaners.com'
// export const base_url = 'https://eda3-182-48-204-207.in.ngrok.io'